module.exports = __webpack_public_path__ + "img/red-warning.ff5b1b3b.png";